import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=184e23b9&"
import script from "./ProductForm.ts?vue&type=script&lang=js&"
export * from "./ProductForm.ts?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports